import React from 'react';
import { SolutionDetailTemplate } from '../shared/SolutionDetailTemplate';

export const WorkplaceSafetyCompliancePage: React.FC = () => {
  return (
    <SolutionDetailTemplate
      title="Workplace Safety & Compliance"
      description="AI-driven systems for proactive safety monitoring and simplified regulatory compliance to ensure secure work environments."
      category="Safety & Compliance"
      categoryColor="#8A3FFC"
      keyFeatures={[
        "Visual recognition of PPE and immediate breach alerts",
        "Automated DGE documentation and compliance tracking",
        "Scalable solutions for diverse worksite environments",
        "Real-time safety monitoring and incident detection",
        "Compliance reporting and audit trail management",
        "Integration with existing safety management systems"
      ]}
      benefits={[
        "Reduce workplace accidents by up to 80%",
        "Ensure 100% compliance with safety regulations",
        "Automate safety monitoring and reporting",
        "Lower insurance premiums through improved safety records",
        "Reduce compliance management overhead",
        "Enable proactive safety interventions",
        "Improve overall workplace safety culture"
      ]}
      useCases={[
        "Construction site safety monitoring",
        "Industrial facility compliance tracking",
        "Oil & gas safety protocol enforcement",
        "Manufacturing floor safety oversight",
        "Healthcare facility compliance management",
        "Laboratory safety and protocol monitoring",
        "Mining operation safety surveillance",
        "Chemical plant safety and environmental compliance"
      ]}
      relatedTools={[
        {
          name: "MVS xAI ",
          description: "Verifies PPE adherence and maintains audit logs.",
          href: "/products/ai/mvsxAi"
        },
        {
          name: "Asset Management",
          description: "Policy enforcement, forensics, and chain‑of‑custody evidence.",
          href: "/products/ai/assetmanagement"
        },
        {
          name: "Predictive Maintenance ",
          description: "Minimizes safety incidents from unplanned failures.",
          href: "/products/ai/predictivemaintenance"
        },
        {
          name: "Water Level IoT ",
          description: "Early‑warning alerts for overflow/flood risk.",
          href: "/products/iot/water-level-iot"
        },
        {
          name: "Panaceon",
          description: "Coding accuracy, auditability, and regulatory compliance support.",
          href: "/products/ai/Panaceon"
        },

      ]}
      industries={[
        "Construction & Infrastructure",
        "Oil & Gas Operations",
        "Manufacturing & Industrial",
        "Healthcare & Life Sciences",
        "Mining & Resources"
      ]}
    />
  );
};